import { useUserReports } from "../fetch/fetch.report";
import ErrMessage from "../components/core/ErrMessage";
import LoadingPage from "../components/core/loading/LoadingPage";
import ReportsList from "../components/report/ReportsList";

function UserReport() {
  const { reports, isLoading, isError } = useUserReports([]);
  if (isError) return <ErrMessage message={isError.message} />;
  if (isLoading) return <LoadingPage />;
  return <ReportsList reportIds={reports} />;
}
export default UserReport;
